import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { TopBar } from './components/TopBar';
import { Dashboard } from './pages/Dashboard';
import { Sites } from './pages/Sites';
import { Estimation } from './pages/Estimation';
import { Contacts } from './pages/Contacts';
type PageType = 'dashboard' | 'sites' | 'estimation' | 'contacts';
export function WebApp() {
  const [currentPage, setCurrentPage] = useState<PageType>('dashboard');
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard data-id="element-437" />;
      case 'sites':
        return <Sites data-id="element-438" />;
      case 'estimation':
        return <Estimation data-id="element-439" />;
      case 'contacts':
        return <Contacts data-id="element-440" />;
      default:
        return <Dashboard data-id="element-441" />;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-442">
      <Sidebar currentPage={currentPage} onPageChange={setCurrentPage} data-id="element-443" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-444">
        <TopBar data-id="element-445" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-446">{renderPage()}</main>
      </div>
    </div>;
}